export default "__VITE_ASSET__DGxPereB__"